const { default: axios } = require('axios');

const axiosInstance = axios.create({
    // baseURL: 'http://localhost:9000'
    baseURL: 'https://goldfish-app-28den.ondigitalocean.app'
});

export default axiosInstance;
